module.exports = __webpack_public_path__ + "media/images/Hero-Product-Cuatro-2-scaled-efefec0da306014cbdd31dae3c433ef3.jpg";